import { Component, ReactNode } from "react";

interface Props {
  children: ReactNode;
}
interface State {
  hasError: boolean;
}

/**
 * Top-level error boundary rendered above <App/>.
 * Uses inline styles so the fallback works even if Tailwind CSS
 * or fonts failed to load.
 */
class RootErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: unknown) {
    // eslint-disable-next-line no-console
    console.error("RootErrorBoundary caught:", error, info);
  }

  private hardReload = () => {
    try {
      sessionStorage.clear();
    } catch {
      /* ignore */
    }
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px",
          fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
          color: "#303030",
          background: "#fff",
          textAlign: "center",
        }}
      >
        <div style={{ maxWidth: 420 }}>
          <h1 style={{ fontSize: 24, marginBottom: 12, fontWeight: 600 }}>
            Что-то пошло не так
          </h1>
          <p style={{ color: "#6b7280", marginBottom: 20, lineHeight: 1.5 }}>
            Не удалось загрузить страницу. Попробуйте обновить — обычно это помогает.
          </p>
          <button
            onClick={this.hardReload}
            style={{
              padding: "10px 22px",
              borderRadius: 9999,
              background: "#FF5331",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              fontSize: 15,
              fontWeight: 500,
            }}
          >
            Обновить страницу
          </button>
        </div>
      </div>
    );
  }
}

export default RootErrorBoundary;
